import { RootState } from 'reducers/rootReducer';
import { PayloadAction } from 'types/payloadAction';

// Action Types
const NAME = 'sketchSearchModal';

const SHOW = `${NAME}/SHOW`;
const HIDE = `${NAME}/HIDE`;

export interface SketchSearchModalState {
  readonly isShowing: boolean;
}

// Initial State
const initialState: SketchSearchModalState = {
  isShowing: false,
};

// Action Creators
export const actions = {
  hide: () => ({ type: HIDE }),
  show: () => ({ type: SHOW }),
};

// Selectors
const getSketchModal = (rootState: RootState): SketchSearchModalState => rootState.sketchSearchModal;

const isShowing = (rootState: RootState): boolean => getSketchModal(rootState).isShowing;

export const selectors = {
  isShowing,
};

// Reducers
const showReducer = (state: SketchSearchModalState): SketchSearchModalState => ({
  ...state,
  isShowing: true,
});

const hideReducer = (state: SketchSearchModalState): SketchSearchModalState => ({
  ...state,
  isShowing: false,
});

export const reducer = (
  state: SketchSearchModalState = initialState,
  action: PayloadAction,
): SketchSearchModalState => {
  switch (action.type) {
    case HIDE:
      return hideReducer(state);

    case SHOW:
      return showReducer(state);

    default:
      return state;
  }
};
